var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getAssetUrl } from '@/helpers/commonFunctions';
import { cn } from '@/lib/utils';
import { useChatMessage } from './hooks/utils';
export default function ChatEntry(_a) {
    var _b, _c;
    var { entry, messageFormatter, hideName, hideTimestamp, className, agentState, audioTrack } = _a, props = __rest(_a, ["entry", "messageFormatter", "hideName", "hideTimestamp", "className", "agentState", "audioTrack"]);
    const { message, hasBeenEdited, time, locale, name } = useChatMessage(entry, messageFormatter);
    const isUser = ((_b = entry.from) === null || _b === void 0 ? void 0 : _b.isLocal) || ((_c = entry.from) === null || _c === void 0 ? void 0 : _c.name) === 'user' ? true : false;
    return (_jsxs("li", Object.assign({ "data-lk-message-origin": isUser ? 'remote' : 'local', title: time.toLocaleTimeString(locale, { timeStyle: 'full' }), className: cn('group flex flex-col gap-1 backdrop-blur-sm', className) }, props, { children: [(!hideTimestamp || !hideName || hasBeenEdited) && (_jsxs("span", { className: "text-muted-foreground flex px-2 text-sm", children: [!hideName && _jsx("strong", { className: "mt-1", children: name }), !hideTimestamp && (_jsxs("span", { className: "ml-auto font-mono text-xs opacity-0 transition-opacity group-hover:opacity-100", children: [hasBeenEdited && '*', time.toLocaleTimeString(locale, { timeStyle: 'short' })] }))] })), _jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 12,
                    justifyContent: isUser ? 'flex-end' : 'flex-start',
                }, children: [!isUser && (_jsxs("div", { style: { position: 'relative', zIndex: 10, alignSelf: 'flex-start' }, children: [_jsx("div", { style: {
                                    position: 'absolute',
                                    inset: 0,
                                    borderRadius: 38,
                                    filter: 'blur(20px)',
                                    background: 'linear-gradient(135deg, rgba(249,115,22,0.2), transparent)',
                                    transition: 'all 300ms',
                                } }), _jsxs("div", { style: {
                                    position: 'relative',
                                    maxWidth: '75vw',
                                    overflow: 'hidden',
                                    borderRadius: 38,
                                    padding: 12,
                                    transform: 'perspective(1000px) translateZ(10px)',
                                    backgroundImage: 'linear-gradient(180deg, rgba(65,40,35,0.5) 0%, rgba(35,20,18,0.7) 100%)',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.4), inset 0 1px 1px rgba(255,255,255,0.15)',
                                    backdropFilter: 'blur(24px)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                    transition: 'all 300ms',
                                }, children: [_jsx("div", { style: {
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            inset: 0,
                                            borderRadius: 38,
                                            boxShadow: 'inset 0 4px 8px rgba(255,255,255,0.15), inset 0 -4px 8px rgba(0,0,0,0.3)',
                                        } }), _jsx("div", { style: {
                                            position: 'relative',
                                            zIndex: 10,
                                            fontWeight: 500,
                                            color: '#fff',
                                            filter: 'drop-shadow(2px 2px 3px rgba(0,0,0,0.45))',
                                        }, children: _jsx("img", { src: getAssetUrl('assets/globe.svg'), alt: "Agent", style: {
                                                height: 40,
                                                width: 40,
                                                borderRadius: '50%',
                                            } }) })] })] })), _jsxs("div", { style: { position: 'relative', zIndex: 10 }, children: [_jsx("div", { style: {
                                    position: 'absolute',
                                    inset: 0,
                                    borderRadius: 38,
                                    filter: 'blur(20px)',
                                    transition: 'all 300ms',
                                    background: isUser
                                        ? 'linear-gradient(135deg, rgba(74,63,112,0.4), rgba(43,38,61,0.3))'
                                        : 'linear-gradient(135deg, rgba(249,115,22,0.2), transparent)',
                                } }), _jsxs("div", { style: {
                                    position: 'relative',
                                    maxWidth: '75vw',
                                    overflow: 'hidden',
                                    borderRadius: 38,
                                    padding: '16px 24px',
                                    transform: 'perspective(1000px) translateZ(10px)',
                                    backgroundImage: isUser
                                        ? 'linear-gradient(180deg, rgba(60,50,80,0.6) 0%, rgba(30,25,40,0.8) 100%)'
                                        : 'linear-gradient(180deg, rgba(65,40,35,0.5) 0%, rgba(35,20,18,0.7) 100%)',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.4), inset 0 1px 1px rgba(255,255,255,0.15)',
                                    backdropFilter: 'blur(24px)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                    transition: 'all 300ms',
                                }, children: [_jsx("div", { style: {
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            inset: 0,
                                            borderRadius: 38,
                                            boxShadow: 'inset 0 4px 8px rgba(255,255,255,0.15), inset 0 -4px 8px rgba(0,0,0,0.3)',
                                        } }), _jsx("div", { style: {
                                            position: 'relative',
                                            zIndex: 10,
                                            fontWeight: 500,
                                            color: '#fff',
                                            filter: 'drop-shadow(2px 2px 3px rgba(0,0,0,0.45))',
                                        }, children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: {
                                                a: (_a) => {
                                                    var { href = '', children } = _a, props = __rest(_a, ["href", "children"]);
                                                    const cleanHref = href.replace(/[.,!?)]*$/, '');
                                                    return (_jsx("a", Object.assign({}, props, { href: cleanHref, target: "_blank", rel: "noopener noreferrer", style: { textDecoration: 'underline', color: '#fff' }, children: children })));
                                                },
                                            }, children: message }) })] })] }), isUser && (_jsxs("div", { style: { position: 'relative', zIndex: 10, alignSelf: 'flex-start' }, children: [_jsx("div", { style: {
                                    position: 'absolute',
                                    inset: 0,
                                    borderRadius: 38,
                                    filter: 'blur(20px)',
                                    background: 'linear-gradient(135deg, rgba(74,63,112,0.4), rgba(43,38,61,0.3))',
                                } }), _jsxs("div", { style: {
                                    position: 'relative',
                                    padding: 12,
                                    borderRadius: 38,
                                    transform: 'perspective(1000px) translateZ(10px)',
                                    backgroundImage: 'linear-gradient(180deg, rgba(60,50,80,0.6) 0%, rgba(30,25,40,0.8) 100%)',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.4), inset 0 1px 1px rgba(255,255,255,0.15)',
                                    backdropFilter: 'blur(24px)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                }, children: [_jsx("div", { style: {
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            inset: 0,
                                            borderRadius: 38,
                                            boxShadow: 'inset 0 4px 8px rgba(255,255,255,0.15), inset 0 -4px 8px rgba(0,0,0,0.3)',
                                        } }), _jsx("img", { src: getAssetUrl('assets/avatar.svg'), alt: "User", style: {
                                            height: 40,
                                            width: 40,
                                            borderRadius: '50%',
                                            position: 'relative',
                                            zIndex: 10,
                                        } })] })] }))] })] })));
}
